"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

require("../rce/languages/en_GB");

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Alternative text:"
  },
  announcement_list_da155734: {
    message: "Announcement List"
  },
  announcements_a4b8ed4a: {
    message: "Announcements"
  },
  assignments_1e02582c: {
    message: "Assignments"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Background Colour, press down to select"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Cancel file upload"
  },
  cancel_image_upload_2c771950: {
    message: "Cancel image upload"
  },
  cc_attribution_f6de631f: {
    message: "CC Attribution"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC Attribution No Derivatives"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC Attribution Non-Commercial"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC Attribution Non-Commercial No Derivatives"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC Attribution Non-Commercial Share Alike"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC Attribution Share Alike"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Check if the image is decorative"
  },
  choose_usage_rights_33683854: {
    message: "Choose usage rights..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "Click any file to insert a download link for that file."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "Click any image to embed the image in the page."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "Click any page to insert a link to that page."
  },
  click_to_embed_image_33107dd8: {
    message: "Click to embed image"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "Click to embed { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "Click to insert a link into the editor."
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Click to insert a link to this item."
  },
  close_flickr_form_b32e600a: {
    message: "Close Flickr form"
  },
  collaborations_5c56c15f: {
    message: "Collaborations"
  },
  copyright_holder_66ee111: {
    message: "Copyright Holder:"
  },
  course_navigation_dd035109: {
    message: "Course Navigation"
  },
  creative_commons_license_725584ae: {
    message: "Creative Commons Licence:"
  },
  decorative_image_fde98579: {
    message: "Decorative image"
  },
  discussions_a5f96392: {
    message: "Discussions"
  },
  discussions_index_6c36ced: {
    message: "Discussions Index"
  },
  embed_image_1080badc: {
    message: "Embed Image"
  },
  enter_search_terms_e397b1f0: {
    message: "enter search terms"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Enter the alternative text for this image"
  },
  file_upload_form_4aaad554: {
    message: "File Upload Form"
  },
  files_c300e900: {
    message: "Files"
  },
  files_index_af7c662b: {
    message: "Files Index"
  },
  folder_705fd2d7: {
    message: "Folder"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Font Size, press down to select"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Formatting, press down to select"
  },
  grades_a61eba0a: {
    message: "Marks"
  },
  group_navigation_99f191a: {
    message: "Group Navigation"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "I have obtained permission to use this file."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "I hold the copyright"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "If you do not select usage rights now, this file will be unpublished after it''s uploaded."
  },
  image_upload_form_7b74079a: {
    message: "Image Upload Form"
  },
  images_7ce26570: {
    message: "Images"
  },
  insert_equella_links_49a8dacd: {
    message: "Insert Equella Links"
  },
  insert_link_6dc23cae: {
    message: "Insert Link"
  },
  insert_math_equation_57c6e767: {
    message: "Insert Maths Equation"
  },
  link_7262adec: {
    message: "Link"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Link to a New Page"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Link to other content in the course."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Link to other content in the group."
  },
  link_to_url_52dd935c: {
    message: "Link to URL"
  },
  links_14b70841: {
    message: "Links"
  },
  load_more_results_460f49a9: {
    message: "Load more results"
  },
  loading_25990131: {
    message: "Loading..."
  },
  loading_failed_b3524381: {
    message: "Loading failed..."
  },
  loading_folders_8d4d5d5a: {
    message: "Loading folders..."
  },
  modules_c4325335: {
    message: "Modules"
  },
  no_results_940393cf: {
    message: "No results."
  },
  pages_e5414c2c: {
    message: "Pages"
  },
  people_b4ebb13c: {
    message: "People"
  },
  quizzes_7e598f57: {
    message: "Quizzes"
  },
  record_upload_media_5fdce166: {
    message: "Record/Upload Media"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Rich Text Area. Press ALT+F8 for help."
  },
  search_280d00bd: {
    message: "Search"
  },
  search_flickr_6884b518: {
    message: "Search Flickr"
  },
  select_a_file_53ba40ac: {
    message: "Select a file"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "Select a folder to upload your file into"
  },
  syllabus_f191f65b: {
    message: "Syllabus"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Text Colour, press down to select"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "The material is in the public domain"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "The material is licensed under Creative Commons"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "The material is subject to fair use exception"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "This upload exceeds the file storage quota. Please speak to your system administrator."
  },
  upload_8b403d05: {
    message: "Upload"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Upload a new file"
  },
  upload_a_new_image_890df275: {
    message: "Upload a new image"
  },
  usage_right_ff96f3e2: {
    message: "Usage Right:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "What would you like to call the new page?"
  },
  wiki_home_9cd54d0: {
    message: "Wiki Home"
  }
};

_formatMessage.default.addLocale({
  "en-AU": locale
});